import Vue from 'vue'

const state = {
  mainConf: null,
};

const mutations = {
  setMainConf (state, menuList) {
    let menus = [];
    if(menuList && menuList.length > 0) {
      menuList.forEach(menu => {
        if(menu.type === 3) {     // 只加载管理端（type=1）的菜单
          menus.push(Vue.prototype._.cloneDeep(menu));
        }
      })
    }
    let handlerMenus = (menu) => {
      menu.menuId = menu.id.toString();
      menu.title = menu.name;
      menu.fromHistory = false;
      if(menu.pid == 0) {
        menu.icon = 'el-icon-' + menu.icon;
      }
      if(menu.url) {
        menu.component = menu.url;
      }
      if(menu.children && menu.children.length > 0) {
        menu.children.forEach(menu => {
          handlerMenus(menu);
        })
      }
      menu.sub = menu.children;
    };
    if(menus && menus.length > 0) {
      menus.forEach(menu => {
        handlerMenus(menu);
      })
    }
    state.mainConf = {
      menu: menus,
      favor: [],
      application: [],
      homeTab: {
        title: '首页',                     //  tab 显示标题
        menuId: 'home',                   //  tab 内部名称(用来识别当前打开的tab)
        components: [{path: 'Home'}],     //  tab 对应的组件
      }
    };
  },
};

const actions = {
  initMainConf({ commit, state }, menuList) {
    commit('setMainConf', menuList);
    commit('frame/SetHomeTab', state.mainConf.homeTab, {root: true});
    commit('frame/SetCurrentTabIndex', state.mainConf.homeTab.menuId, {root: true});
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js